export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  chart: (state) => state.chart,
  overview: (state) => state.overview,
  eventChart: (state) => state.eventChart,
  eventOverview: (state) => state.eventOverview,
};
